import React, { useEffect, useRef } from 'react';
import { useDispatch , useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { setPage } from '../../redux/actions/commonActions';
import { createCallUrl, createCallSelectorUrl } from '../../utils/common';


export const CallConfirm = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { common, ui } = useSelector(state => state);

  const config = ui?.config?.attributes;
  const LeaveChat = config?.LeaveChat;


  useEffect(() => {
    dispatch(setPage('call-confirm'));
    document.body.style.overflow = "auto";

    const timer = setTimeout(() => {
      clickBackChat(); // Trigger "No" option if no response after 5 seconds
    }, 5000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, [dispatch]);

  const clickBackChat = ()=>{
    dispatch(setPage('chat'))
    document.body.style.overflow = "hidden";
  }

  const leaveChat = ()=>{
      const currentUrl = new URL(window.location.href);
  
      const domain = `${currentUrl.origin}`;
      const pathParts = currentUrl.pathname.split('/').filter(part => part); // Split path into parts
      const lang = pathParts[0];
      const brand = pathParts[1];
      const sParam = currentUrl.searchParams.get('s');
      
      // Construct the new URL
      let navigateUrl = `/call/${brand}?lang=${lang}`;
      if (sParam) {
        navigateUrl += `&s=${sParam}`;
      }

      navigate(navigateUrl);
  }
  

  return  (
  <>
      <div className="leave-chat-wrapper">
          <div className="live-chat-container text-center mt-15">
              {/* <img src={ leaveChatImage } /> */}
              <h2>{ LeaveChat?.LeaveChatConfirmation }</h2>
              <button onClick={ leaveChat } className="btn-leave">{ LeaveChat?.Yes }</button>
              <button onClick={ clickBackChat} className="btn-leave">{ LeaveChat?.No }</button>
          </div>
      </div>

  </>
  )
}

export default CallConfirm;